import { queryKeys } from '@query/keys'
import { useQuery } from '@tanstack/react-query'

import { Operator, useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { AccountGroupType } from '@model/AccountGroupType'
import { PlatformTypeEnum } from '@model/PlatformTypeEnum'
import { TradingAccountStatusType } from '@model/TradingAccount'

export const useTradingAccountStatus = (): {
  hasNegativeBalance: boolean
  hasActiveTradingAccounts: boolean
  isLoading: boolean
} => {
  const apiClient = useApiClient(ClientApiClient)

  const { data: tradingAccountStatus, isLoading } = useQuery({
    queryKey: queryKeys.tradingAccountStatus(),
    queryFn: async () => {
      const result = await apiClient.getTradingAccounts({
        pageSize: 1000,
        search: {
          AccountGroupType: { value: AccountGroupType.Live, operator: Operator.EQUAL },
          Status: { value: TradingAccountStatusType.Approved, operator: Operator.EQUAL },
          Platform: {
            value: PlatformTypeEnum.CQGCAST,
            operator: Operator.NOT_EQUAL,
          },
        },
        refetchOnMount: 'always',
      })

      return {
        hasNegativeBalance: result.items.some((account) => account.platformOverview.equity < 0),
        hasActiveTradingAccounts: result.items.some(
          (item) => item.status.id === TradingAccountStatusType.Approved
        ),
      }
    },
  })

  return {
    hasNegativeBalance: tradingAccountStatus?.hasNegativeBalance ?? false,
    hasActiveTradingAccounts: tradingAccountStatus?.hasActiveTradingAccounts ?? false,
    isLoading,
  }
}
